import gql from 'graphql-tag';
import { useQuery } from '@apollo/react-hooks';
import type { PanelApplication, SearchPanelApplication } from './types';

/**
 * @deprecated
 */
const SEARCH_PANEL_APPLICATION = gql`
  query ($filter: ApplicationFilter) {
    applications(filter: $filter) {
      _id
      applicationNo
      applicant {
        name {
          givenName
          surname
        }
      }
      programmeChoice {
        department
      }
    }
  }
`;

export const useSearchPanelApplication = (
  filter: any,
): SearchPanelApplication => {
  const { data, loading, error, refetch } = useQuery(SEARCH_PANEL_APPLICATION, {
    variables: { filter },
    fetchPolicy: 'network-only',
    skip: !(filter as boolean),
  });

  const applications = data?.applications ?? [];

  const panelApplications: PanelApplication[] = applications.map(
    (application: any) => {
      const { _id, applicationNo, applicant, programmeChoice } =
        application ?? {};
      return {
        applicationId: _id,
        applicationNo,
        applicantName: `${applicant?.name?.surname?.toUpperCase()} ${applicant?.name?.givenName}`,
        department: programmeChoice?.department,
      };
    },
  );

  return {
    panelApplications,
    loading,
    error,
    refetch,
  };
};
